import React from 'react'

import Slider from './slider'
import Count from './count'
import Expertise from './expertise'
import DirectorCard from './directorCard'
import Definition from './definition'
import Opener from './opener'
import Navbar from '../../components/navbar'

const Home = () => {
  return (
    <div className='home'>
      <Navbar />
      <Slider />
      <Count />
      <Expertise />
      <DirectorCard />
      <Definition />
    </div>
  )
}

export default Home
